import React, { useState, useEffect } from 'react'
import { Popover, Select, Button } from 'antd'
import camelCase from 'lodash/camelCase'
import IntlMessages from '../../util/IntlMessages'
import { IExportFilterProps, IFilterPopoverProps } from './types'

const { Option } = Select

const FilterPopover: React.FC<IFilterPopoverProps> = ({
  filterType,
  options,
  label,
  selectedValues,
  onApply,
  onReset,
  triggerIcon,
}) => {
  const [tempValues, setTempValues] = useState<string[]>(selectedValues || [])
  const [visible, setVisible] = useState(false)
  const [selectOpen, setSelectOpen] = useState(false)

  useEffect(() => {
    setTempValues(selectedValues || [])
  }, [selectedValues])

  const handleChange = (value: string[]) => {
    setTempValues(value)
  }

  const handleApply = () => {
    onApply(filterType, tempValues)
    setSelectOpen(false)
    setVisible(false)
  }

  const handleReset = () => {
    setTempValues([])
    onReset(filterType)
    setSelectOpen(false)
    setVisible(false)
  }

  const handleVisibleChange = (newVisible: boolean) => {
    if (!newVisible) {
      setTempValues(selectedValues || [])
    }
    setVisible(newVisible)
  }

  return (
    <Popover
      content={
        <div>
          <Select
            mode='multiple'
            style={{ width: 240 }}
            placeholder={<IntlMessages id='app.select' />}
            value={tempValues}
            onChange={handleChange}
            open={selectOpen}
            onDropdownVisibleChange={setSelectOpen}
            getPopupContainer={(trigger) => trigger.parentElement as HTMLElement}
            dropdownRender={(menu) => (
              <div>
                {menu}
                <div className='report-select-menu-footer'>
                  <Button type='primary' onClick={handleApply} style={{ marginRight: 8 }}>
                    <IntlMessages id='app.apply' />
                  </Button>
                  <Button onClick={handleReset}>
                    <IntlMessages id='app.reset' />
                  </Button>
                </div>
              </div>
            )}
            optionFilterProp='children'
            showSearch
          >
            {options.map((option: IExportFilterProps) => (
              <Option key={option.id} value={option.id}>
                {option.name}
              </Option>
            ))}
          </Select>
          {!selectOpen && (
            <div style={{ marginTop: 10 }}>
              <Button type='primary' onClick={handleApply} style={{ marginRight: 8 }}>
                <IntlMessages id='app.apply' />
              </Button>
              <Button onClick={handleReset}>
                <IntlMessages id='app.reset' />
              </Button>
            </div>
          )}
        </div>
      }
      title={<IntlMessages id={`app.${camelCase(label)}`} />}
      trigger="click"
      placement="bottom"
      open={visible}
      onOpenChange={handleVisibleChange}
    >
      {triggerIcon}
    </Popover>
  )
}

export default FilterPopover
